import { render, staticRenderFns } from "./resultadoNps.vue?vue&type=template&id=650e3892&scoped=true"
import script from "./resultadoNps.vue?vue&type=script&lang=js"
export * from "./resultadoNps.vue?vue&type=script&lang=js"
import style0 from "./resultadoNps.vue?vue&type=style&index=0&id=650e3892&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "650e3892",
  null
  
)

export default component.exports